import { useState } from 'react';
import { useAuth } from '@/contexts/auth-context';
import { toast } from '@/hooks/use-toast';

const usePhieuKeToanTheoNghiepVuExport = () => {
  const [isExporting, setIsExporting] = useState(false);
  const { entity } = useAuth();

  const exportToExcel = async () => {
    setIsExporting(true);
    try {
      const { exportPhieuKeToanTheoNghiepVuExcel, exportPhieuKeToanTheoNghiepVuFromApi } =
        await import('../utils/export-excel');
      if (entity?.slug) {
        await exportPhieuKeToanTheoNghiepVuFromApi({
          entitySlug: entity.slug
        });
        return;
      }

      await exportPhieuKeToanTheoNghiepVuExcel();
    } catch (error) {
      toast({
        description: 'Không thể kết xuất dữ liệu.',
        variant: 'destructive'
      });
    } finally {
      setIsExporting(false);
    }
  };

  return {
    exportToExcel,
    canExport: Boolean(entity?.slug),
    isExporting
  };
};

export default usePhieuKeToanTheoNghiepVuExport;
